import { render } from "./remoteLogin.vue?vue&type=template&id=25825b25&scoped=true"
import script from "./remoteLogin.vue?vue&type=script&lang=js"
export * from "./remoteLogin.vue?vue&type=script&lang=js"

import "./remoteLogin.vue?vue&type=style&index=0&id=25825b25&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-25825b25"

export default script